/**
 * Short-lived Plaid **link token** only (TMMAPP-0024). Never the public token, never an
 * access token. Expired at `expiresAt`. The token is never logged.
 */
export const PLAID_LINK_KEY = 'tmm_plaid_link';

export interface StoredPlaidLink {
  token: string;
  itemId?: number | undefined;
  startedAt: string;
  expiresAt: string | null;
}

function asRecord(value: unknown): Record<string, unknown> {
  return typeof value === 'object' && value !== null ? (value as Record<string, unknown>) : {};
}

export function storePlaidLink(value: StoredPlaidLink): void {
  sessionStorage.setItem(PLAID_LINK_KEY, JSON.stringify(value));
}

export function clearPlaidLink(): void {
  sessionStorage.removeItem(PLAID_LINK_KEY);
}

export function readPlaidLink(now = Date.now()): StoredPlaidLink | null {
  const raw = sessionStorage.getItem(PLAID_LINK_KEY);
  if (raw === null) return null;
  try {
    const w = asRecord(JSON.parse(raw) as unknown);
    if (typeof w.token !== 'string' || w.token.length === 0) {
      clearPlaidLink();
      return null;
    }
    const expiresAt = typeof w.expiresAt === 'string' ? w.expiresAt : null;
    if (expiresAt !== null) {
      const expiry = Date.parse(expiresAt);
      if (!Number.isNaN(expiry) && expiry <= now) {
        clearPlaidLink();
        return null;
      }
    }
    return {
      token: w.token,
      ...(typeof w.itemId === 'number' ? { itemId: w.itemId } : {}),
      startedAt: typeof w.startedAt === 'string' ? w.startedAt : new Date(now).toISOString(),
      expiresAt,
    };
  } catch {
    clearPlaidLink();
    return null;
  }
}
